var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill no-overflow"},[_c('InputTable',{attrs:{"tableSetup":_vm.tableSetup,"headerRow":_vm.headerConfig,"labelWidth":"14rem"},on:{"change":_vm.inputEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }